// This module deliberately imports no app bootstrap, credentials or analytics.
const uuidPattern =
  '[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}'
const sharedPath = new RegExp(`^/shared-dashboards/(${uuidPattern})/?$`, 'i')

export const sharedDashboardUuid = (path: string) => sharedPath.exec(path)?.[1]
export const isSharedDashboardEntry = (path: string) =>
  /^\/shared-dashboards(?:\/|$)/i.test(path)
export const sharedDashboardReturn = (search: string): string | undefined => {
  const value = new URLSearchParams(search).get('redirect') ?? ''
  const path = value.startsWith('/') ? value : `/${value}`
  return sharedDashboardUuid(path) ? path : undefined
}
export const isDashboardSharingLocation = (
  location: Pick<Location, 'pathname' | 'search'>,
) =>
  isSharedDashboardEntry(location.pathname) ||
  !!sharedDashboardReturn(location.search)

export const sharedDashboardLogin = (path: string, search = '') => {
  const destination = sharedDashboardUuid(path)
    ? path
    : sharedDashboardReturn(search)
  return destination
    ? `/login?redirect=${encodeURIComponent(destination)}`
    : '/login'
}

// One ID per mounted viewer; never persist it, so a reload or another tab is another opening.
export const createSharedViewId = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(16))
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const hex = Array.from(bytes, byte =>
    byte.toString(16).padStart(2, '0'),
  ).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16,
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
